import Modal from "components/common/Modal";
import React, { FC } from "react";
import HtmlRenderer from "./HtmlRenderer";
import { regextForDiv } from "utils/utils";

interface ListModalProps {
  isOpen: any;
  onClose: any;
  content: any;
  heading: string | boolean;
}

const ListModal: FC<ListModalProps> = ({ isOpen, onClose, content, heading }) => {
  if (regextForDiv.test(content)) {
    return <HtmlRenderer heading={heading} isOpen={isOpen} onClose={onClose} content={content} />;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-[35rem] pb-2" headerClassName="bg-[#F0F4FD] py-4 rounded-t-lg -mt-5" header={<p className="font-bold">{heading}</p>}>
      <div className="p-5  max-h-[26rem] overflow-auto rounded-br-xl custom-scrollbar ">
        {content && Array.isArray(content) ? (
          content.every((item) => typeof item === "string") ? (
            content.map((obj: string, index: number) => (
              <div key={index} className={`flex gap-3 items-center mb-3 ${index === content.length - 1 ? "pb-1" : "pb-3"} ${index !== content.length - 1 && "border-[#cccccc] border-dashed border-b-[1px]"}`}>
                <p className="bg-[#C4C678] w-3 h-3 flex-shrink-0"></p>
                <p className="font-bold text-sm">{obj}</p>
              </div>
            ))
          ) : (
            <table className="w-full border border-[#E6E6E6] rounded-[15px] border-separate border-spacing-0 text-left font-nunito text-[14px] mt-5 overflow-hidden">
              <thead>
                <tr className="bg-[#DEE4DA] font-extrabold text-[16px]">
                  <th className="border border-[#E6E6E6] px-4 py-2 w-[20%]">Duration</th>
                  <th className="border border-[#E6E6E6] px-4 py-2 w-[80%]">List</th>
                </tr>
              </thead>
              <tbody>
                {content.map((obj: any, index: number) => (
                  <tr key={index} className="align-top">
                    <td className="border border-[#E6E6E6] px-4 py-2 font-extrabold">{obj.duration}</td>
                    <td className="border border-[#E6E6E6] px-4 py-2 font-extrabold bg-[#F3FFEA]">
                      <ul className="list-disc list-inside space-y-1">
                        {Array.isArray(obj.list) &&
                          obj.list.map((item: string, idx: number) => (
                            <li key={idx}>
                              {item.split("\n").map((line, lidx) => {
                                const isSubItem = line.trim().startsWith("*");
                                return (
                                  <span key={lidx} className={isSubItem ? "pl-4 font-normal text-[13px]" : ""}>
                                    {line}
                                    {lidx !== item.split("\n").length - 1 && <br />}
                                  </span>
                                );
                              })}
                            </li>
                          ))}
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        ) : null}
      </div>
    </Modal>
  );
};

export default ListModal;
